<template>
  <div>
    <PageAllow controller="TaskLogs" action="getSyncErrLogs" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="func"
                    v-model="options.func"
                    @text="func = $event"
                    :label="$t('TaskSyncErrLogs.Fields.func')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                          ref="param"
                          v-model="options.param"
                          @text="param = $event"
                          :label="$t('TaskSyncErrLogs.Fields.param')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="logs"
          :options.sync="options"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          :page.sync="paging.page"
          :server-items-length="paging.count"
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Logs from "@/api/logs";
import i18n from "@/i18n";


const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  func: "",
  param: ""
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("task-sync-err-logs-options")
        ? sessionStorage.getItem("task-sync-err-logs-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    func: "",
    param:"",
    logs: [],
    paging: {}
  }),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.accountLogs"),
        disabled: false,
        href: "/settings/task-sync-err-logs",
      },
      {
        text: i18n.t("SettingNav.taskSyncErrLogs"),
        disabled: true,
        href: "/settings/task-sync-err-logs",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("TaskSyncErrLogs.date"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("TaskSyncErrLogs.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TaskSyncErrLogs.Fields.func"),
        align: "start",
        sortable: false,
        value: "func",
      },
      {
        text: i18n.t("TaskSyncErrLogs.Fields.param"),
        align: "center",
        sortable: false,
        value: "param",
      },
      {
        text: i18n.t("TaskSyncErrLogs.Fields.msg"),
        align: "center",
        sortable: false,
        value: "msg",
      }
    ],
  },
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
  },
  methods: {
    onSearch() {
      this.options = Object.assign({},this.options, {
        func: this.func,
        param: this.param
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getLogsFromAPI() {
      this.loading = true;
      Logs.fetchSyncErrs(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.logs = response.data.logs;

            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        sessionStorage.setItem("task-sync-err-logs-options", JSON.stringify(this.options));
        this.getLogsFromAPI();
      },
    },
    
  },
};
</script>

<style>
</style>